import { currentSite } from '@src/app/utils/domainHelpers';
import { Theme } from '@superbet-group/web.lib.ui-components';
import {
    NavigationContext,
    Site,
} from '@superbet-group/web.types';

const themeKey = 'theme:';
const lastThemeKey = 'theme:recent';

const sportsSites = new Set<string>([Site.NapoleonSports]);
const gamingSites = new Set<string>([Site.NapoleonCasino, Site.NapoleonDice, Site.NapoleonGames, Site.NapoleonGamesRo]);

export function getBootingTheme(maybeContext?: NavigationContext): Theme {
    if (maybeContext) {
        return getTheme(maybeContext);
    } else if (sportsSites.has(currentSite)) {
        return getTheme(NavigationContext.Sports);
    } else if (gamingSites.has(currentSite)) {
        return getTheme(NavigationContext.Casino);
    } else {
        return getLastVisitedTheme() ?? getSystemTheme();
    }
}

export function getSelectedTheme(context: NavigationContext): Theme | undefined {
    const key = `${themeKey}${context}`;
    return localStorage.getItem(key) as Theme;
}

export function getTheme(context: NavigationContext): Theme {
    const savedTheme = getSelectedTheme(context);
    const themeOptions = Object.values(Theme);

    if (savedTheme && themeOptions.includes(savedTheme)) {
        return savedTheme;
    } else {
        return getDefaultTheme(context);
    }
}

export function applyTheme(context: NavigationContext): void {
    if (context === NavigationContext.Neutral) {
        return;
    }

    const theme = getTheme(context);
    setHtmlTheme(theme);
}

export function getSystemTheme(): Theme {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? Theme.Dark : Theme.Light;
}

export function setHtmlTheme(theme: Theme) {
    document.querySelector('html')!.dataset.theme = theme;
}

export function getHtmlTheme(): Theme {
    return document.querySelector('html')!.dataset.theme as Theme ?? getSystemTheme();
}

export function saveTheme(context: NavigationContext, theme: Theme): void {
    const key = `${themeKey}${context}`;
    localStorage.setItem(key, theme);
}

export function removeThemePreference(context: NavigationContext): void {
    const key = `${themeKey}${context}`;
    localStorage.removeItem(key);
}

export function recordLastVisitedTheme(): void {
    localStorage.setItem(lastThemeKey, getHtmlTheme());
}

function getLastVisitedTheme(): Theme | undefined {
    return localStorage.getItem(lastThemeKey) as Theme;
}

export function getDefaultTheme(context: NavigationContext): Theme {
    switch (context) {
        case NavigationContext.Sports:
            // return getSystemTheme();
            return Theme.Light;
        case NavigationContext.Casino:
            return Theme.Dark;
        default:
            // return getSystemTheme();
            return Theme.Light;
    }
}
